// AUTO-GENERATED by tools/version/generate-version.ts. Do not edit.
export const APP_VERSION = "2026.11.03-dev.389";
export const GIT_SHA = "fcbb5f79753ee23c39f54c6bc973f68cfed2e293";
export const BUILD_TIME = "2026-11-03T15:09:45.140Z";
